'use client'

import React from 'react'

import { useLockBodyScroll } from '../../hooks'
import { Close } from '../../icons'
import {
  Backdrop,
  CircleIconButton,
  Container,
  Heading,
  List,
  ListItem,
  Pane,
  Section,
} from './styles'

export interface SidebarProps {
  open: boolean
  onClose: () => void
  children?: React.ReactNode
}

type SidebarComponent = React.FC<SidebarProps> & {
  Section: typeof Section
  Heading: typeof Heading
  List: typeof List
  ListItem: typeof ListItem
  CircleIconButton: typeof CircleIconButton
}

export const Sidebar: SidebarComponent = ({
  open,
  onClose,
  children,
}: SidebarProps) => {
  const [isAnimating, setAnimating] = React.useState(false)

  useLockBodyScroll(open)

  React.useEffect(() => {
    if (!open) return
    setAnimating(true)
  }, [open])

  return (
    <Container isVisible={isAnimating}>
      <Backdrop open={open} onClick={onClose} />

      <Pane.Container
        open={open}
        onTransitionEnd={() => {
          if (!open) setAnimating(false)
        }}
      >
        <Pane.Inner>
          <Pane.ButtonContainer>
            <Pane.CloseButton onClick={onClose}>
              <Close />
            </Pane.CloseButton>
          </Pane.ButtonContainer>

          <Pane.Content>{children}</Pane.Content>
        </Pane.Inner>
      </Pane.Container>
    </Container>
  )
}

Sidebar.Section = Section
Sidebar.Heading = Heading
Sidebar.List = List
Sidebar.ListItem = ListItem
Sidebar.CircleIconButton = CircleIconButton
